import React, { createContext, useState } from "react";

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedServiceType, setSelectedServiceType] = useState('primary_care');
  return (
    <LocationContext.Provider value={{
      selectedLocation, setSelectedLocation,
      selectedServiceType, setSelectedServiceType,
    }}>
      {children}
    </LocationContext.Provider>
  );
};
